import { EmptyState, EmptyStateIllustrationImage } from 'components/EmptyState'
import { observer } from 'mobx-react'
import React from 'react'

export default observer(function OCRScopeJobErrorOccurred() {
  return (
    <EmptyState
      image={
        <EmptyStateIllustrationImage
          src={require('assets/images/img_remove-collaborator.svg')}
        />
      }
      title={'OCR scoping failed'}
      subtitle={
        'There was an issue with the uploaded files, so our team will create this job on your behalf. When ready, the job will be visible on the job management table.'
      }
      animate
      small
    ></EmptyState>
  )
})
